export interface SubCategory {
  id: string;
  name: string;
}

export interface Category {
  id: string;
  name: string;
  icon: string;
  description: string;
  gradientFrom: string;
  gradientTo: string;
  glowColor: string;
  subcategories: SubCategory[];
  isHot?: boolean;
  isTodayFeatured?: boolean;
  isPersonalized?: boolean;
  clickCount?: number;
}

export const categories: Category[] = [
  {
    id: 'guzellik',
    name: 'GÜZELLİK',
    icon: 'ri-sparkling-2-line',
    description: 'Lazer, cilt bakımı ve estetik kampanyaları',
    gradientFrom: '#ff6b9d',
    gradientTo: '#c44dff',
    glowColor: 'rgba(196, 77, 255, 0.4)',
    isHot: true,
    isTodayFeatured: true,
    isPersonalized: true,
    clickCount: 12840,
    subcategories: [
      { id: 'guzellik-lazer', name: 'Lazer Epilasyon' },
      { id: 'guzellik-cilt', name: 'Cilt Bakımı' },
      { id: 'guzellik-makyaj', name: 'Kalıcı Makyaj' },
      { id: 'guzellik-zayiflama', name: 'Bölgesel Zayıflama' },
      { id: 'guzellik-g5', name: 'G5 Masaj' },
      { id: 'guzellik-emslim', name: 'Emslim' },
      { id: 'guzellik-genel', name: 'Genel Güzellik' },
    ],
  },
  {
    id: 'sac',
    name: 'SAÇ & KUAFÖR',
    icon: 'ri-scissors-line',
    description: 'Mikro kaynak, ombre ve özel saç bakım fırsatları',
    gradientFrom: '#a855f7',
    gradientTo: '#6366f1',
    glowColor: 'rgba(168, 85, 247, 0.4)',
    isHot: true,
    isTodayFeatured: true,
    clickCount: 9320,
    subcategories: [
      { id: 'sac-mikro', name: 'Mikro Kaynak' },
      { id: 'sac-ombre', name: 'Ombre / Sombre' },
      { id: 'sac-keratin', name: 'Keratin Bakım' },
      { id: 'sac-fon', name: 'Kalıcı Fön' },
      { id: 'sac-perma', name: 'Perma' },
      { id: 'sac-genel', name: 'Genel Saç İşlemleri' },
    ],
  },
  {
    id: 'spor',
    name: 'SPOR & SAĞLIK',
    icon: 'ri-run-line',
    description: 'Fitness, pilates ve sağlıklı yaşam kampanyaları',
    gradientFrom: '#22d3ee',
    gradientTo: '#10b981',
    glowColor: 'rgba(34, 211, 238, 0.4)',
    isHot: false,
    isTodayFeatured: true,
    isPersonalized: true,
    clickCount: 7450,
    subcategories: [
      { id: 'spor-fitness', name: 'Fitness' },
      { id: 'spor-pilates', name: 'Pilates' },
      { id: 'spor-diyetisyen', name: 'Diyetisyen' },
      { id: 'spor-antrenor', name: 'Kişisel Antrenör' },
      { id: 'spor-genel', name: 'Genel Spor' },
    ],
  },
  {
    id: 'egitim',
    name: 'EĞİTİM',
    icon: 'ri-graduation-cap-line',
    description: 'Online kurs, sertifika ve kişisel gelişim',
    gradientFrom: '#f59e0b',
    gradientTo: '#ef4444',
    glowColor: 'rgba(245, 158, 11, 0.4)',
    isHot: false,
    isTodayFeatured: false,
    isPersonalized: true,
    clickCount: 5670,
    subcategories: [
      { id: 'egitim-online', name: 'Online Eğitimler' },
      { id: 'egitim-sertifika', name: 'Sertifikalar' },
      { id: 'egitim-meslek', name: 'Meslek Kursları' },
      { id: 'egitim-gelisim', name: 'Kişisel Gelişim' },
    ],
  },
  {
    id: 'ev',
    name: 'EV HİZMETLERİ',
    icon: 'ri-home-4-line',
    description: 'Temizlik, halı yıkama ve ev taşıma hizmetleri',
    gradientFrom: '#fb923c',
    gradientTo: '#f43f5e',
    glowColor: 'rgba(251, 146, 60, 0.4)',
    isHot: false,
    isTodayFeatured: false,
    isPersonalized: false,
    clickCount: 4230,
    subcategories: [
      { id: 'ev-temizlik', name: 'Temizlik' },
      { id: 'ev-hali', name: 'Halı Yıkama' },
      { id: 'ev-koltuk', name: 'Koltuk Yıkama' },
      { id: 'ev-tasima', name: 'Ev Taşıma' },
    ],
  },
  {
    id: 'otomotiv',
    name: 'OTOMOTİV',
    icon: 'ri-car-line',
    description: 'Araç kiralama, servis ve oto bakım fırsatları',
    gradientFrom: '#38bdf8',
    gradientTo: '#818cf8',
    glowColor: 'rgba(56, 189, 248, 0.4)',
    isHot: true,
    isTodayFeatured: false,
    isPersonalized: false,
    clickCount: 6180,
    subcategories: [
      { id: 'oto-kiralama', name: 'Araç Kiralama' },
      { id: 'oto-servis', name: 'Servis / Bakım' },
      { id: 'oto-kuafor', name: 'Oto Kuaför' },
      { id: 'oto-ekspertiz', name: 'Ekspertiz' },
    ],
  },
  {
    id: 'seyahat',
    name: 'SEYAHAT & TURİZM',
    icon: 'ri-flight-takeoff-line',
    description: 'Otel, transfer ve tatil paketi kampanyaları',
    gradientFrom: '#06b6d4',
    gradientTo: '#0ea5e9',
    glowColor: 'rgba(6, 182, 212, 0.4)',
    isHot: true,
    isTodayFeatured: true,
    isPersonalized: true,
    clickCount: 8910,
    subcategories: [
      { id: 'seyahat-otel', name: 'Otel' },
      { id: 'seyahat-transfer', name: 'Transfer' },
      { id: 'seyahat-tatil', name: 'Tatil Paketleri' },
    ],
  },
  {
    id: 'diger',
    name: 'DİĞER',
    icon: 'ri-gift-2-line',
    description: 'Hediyelik, organizasyon, fotoğrafçılık ve danışmanlık',
    gradientFrom: '#d946ef',
    gradientTo: '#ec4899',
    glowColor: 'rgba(217, 70, 239, 0.4)',
    isHot: false,
    isTodayFeatured: false,
    isPersonalized: false,
    clickCount: 2890,
    subcategories: [
      { id: 'diger-hediye', name: 'Hediyelik' },
      { id: 'diger-organizasyon', name: 'Organizasyon' },
      { id: 'diger-fotograf', name: 'Fotoğrafçılık' },
      { id: 'diger-danismanlik', name: 'Danışmanlık' },
    ],
  },
];

export const topCategories: Category[] = categories.filter((c) => c.isHot);
export const todayFeatured: Category[] = categories.filter((c) => c.isTodayFeatured);
export const personalizedCategories: Category[] = categories.filter((c) => c.isPersonalized);
